export { Title1, Title2, Title6, Title7 } from './Headings';
